module.exports = __webpack_public_path__ + "media/images/dashboard/payment/unionpay-card-13ee716c8dce898f7c548d4cc621b663.jpeg";